const localConfig = {
  baseURL: "/api",
};

export default localConfig;
